import UV from './UV'

const actions = {
  ...UV
}

export default actions
